import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import Image = Phaser.GameObjects.Image;
import SpriteUtils from "@/utils/sprite-utils";
import ParticleUtils from "@/utils/particle-utils";
import CU from "@/utils/c-u";
import Tween = Phaser.Tweens.Tween;

export default class RoadLesson extends Phaser.GameObjects.Container {

    private readonly HAND_IMAGE: string = 'finger_image';
    private readonly HAND_IMAGE_SHADOW: string = 'finger_image_shadow';
    private readonly WIDTH: number = 199 * CU.S;
    private readonly HEIGHT: number = 206 * CU.S;
    private readonly DEPTH: number = 100;
    private readonly ORIGIN_X: number = 0.2;
    private readonly ORIGIN_Y: number = 0.4;
    private readonly RUN_LESSON_DELAY: number = 300;

    private enabled: boolean = true;

    private tweenHand: Tween | undefined;
    private tweenShadow: Tween | undefined;

    constructor(scene: Scene, x: number, y: number) {
        super(scene)
        this.scene = scene;
        this.enabled = true;

        this.y = y;
        this.x = x;

        this.setVisible(false);
        this.setSize(this.WIDTH, this.HEIGHT);
        this.setDepth(this.DEPTH);

        let handImage = SpriteUtils.addImage(this.scene, 0,0, Keys.IMG_LESSON_HAND)
            .setOrigin(this.ORIGIN_X, this.ORIGIN_Y)
            .setName(this.HAND_IMAGE)
        SpriteUtils.setDispSize(handImage, this.WIDTH, this.HEIGHT);

        let handImageShadow = SpriteUtils.addImage(this.scene, 0,0, Keys.IMG_LESSON_HAND_SHADOW)
            .setOrigin(this.ORIGIN_X, this.ORIGIN_Y)
            .setName(this.HAND_IMAGE_SHADOW);
        SpriteUtils.setDispSize(handImageShadow, this.WIDTH, this.HEIGHT);

        this.add([handImageShadow,handImage]);

    }

    public showLesson() {
        let self = this;
        this.scene.time.delayedCall(this.RUN_LESSON_DELAY, () =>{
            if (self.enabled) {
                this.setVisible(true);
                this.showHandAnimations()
            }
        });
    }

    private showHandAnimations() {
        let self = this;

        let hand = this.getByName(this.HAND_IMAGE) as Image;
        let shadow = this.getByName(this.HAND_IMAGE_SHADOW) as Image;

        let duration = 1200;

        let offsetX = 50;
        let offsetY = 30;

        let ease = 'Quad.easeOut';

        if (this.scene) {
            self.tweenHand = this.scene.tweens.add({
                targets: hand,
                duration: duration,
                x: hand.x + offsetX,
                y: hand.y - offsetY,
                ease: ease,
                yoyo: true,
                loop: -1,

                onLoop() {
                    ParticleUtils.showParticleWave(self.scene, self.x + 8, self.y - 38);
                }

            });

            self.tweenShadow = this.scene.tweens.add({
                targets: shadow,
                duration: duration,
                x: shadow.x - offsetX,
                y: shadow.y + offsetY,
                ease: ease,
                yoyo: true,
                loop: -1,
            });
        }
    }

    public destroyLesson() {
        if (this.scene && this.scene.tweens) {
            if (this.tweenHand && this.tweenHand.isActive()) {
                this.tweenHand.destroy();
                this.tweenHand = undefined;
            }
            if (this.tweenShadow && this.tweenShadow.isActive()) {
                this.tweenShadow.destroy();
                this.tweenShadow = undefined;
            }
        }
        this.enabled = false;
        this.setVisible(false);
        this.destroy();
    }
}
